import React from "react";

const SettingIcon = ({className}) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      style={{ fill: "none" }}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
        fill="#111827"
      />
      <path
        d="M15.58 19.25C15.17 19.25 14.83 18.91 14.83 18.5V14.6C14.83 14.19 15.17 13.85 15.58 13.85C15.99 13.85 16.33 14.19 16.33 14.6V18.5C16.33 18.91 15.99 19.25 15.58 19.25Z"
        fill="#111827"
      />
      <path
        d="M15.58 8.2C15.17 8.2 14.83 7.86 14.83 7.45V5.5C14.83 5.09 15.17 4.75 15.58 4.75C15.99 4.75 16.33 5.09 16.33 5.5V7.45C16.33 7.86 15.99 8.2 15.58 8.2Z"
        fill="#111827"
      />
      <path
        d="M15.58 13.4C13.73 13.4 12.23 11.9 12.23 10.05C12.23 8.2 13.73 6.7 15.58 6.7C17.43 6.7 18.93 8.2 18.93 10.05C18.93 11.9 17.42 13.4 15.58 13.4ZM15.58 8.2C14.56 8.2 13.73 9.03 13.73 10.05C13.73 11.07 14.56 11.9 15.58 11.9C16.6 11.9 17.43 11.07 17.43 10.05C17.43 9.03 16.59 8.2 15.58 8.2Z"
        fill="#111827"
      />
      <path
        d="M8.41998 19.25C8.00998 19.25 7.66998 18.91 7.66998 18.5V16.55C7.66998 16.14 8.00998 15.8 8.41998 15.8C8.82998 15.8 9.16998 16.14 9.16998 16.55V18.5C9.16998 18.91 8.83998 19.25 8.41998 19.25Z"
        fill="#111827"
      />
      <path
        d="M8.41998 10.15C8.00998 10.15 7.66998 9.81 7.66998 9.4V5.5C7.66998 5.09 8.00998 4.75 8.41998 4.75C8.82998 4.75 9.16998 5.09 9.16998 5.5V9.4C9.16998 9.81 8.83998 10.15 8.41998 10.15Z"
        fill="#111827"
      />
      <path
        d="M8.42001 17.3C6.57001 17.3 5.07001 15.8 5.07001 13.95C5.07001 12.1 6.57001 10.6 8.42001 10.6C10.27 10.6 11.77 12.1 11.77 13.95C11.77 15.8 10.27 17.3 8.42001 17.3ZM8.42001 12.1C7.40001 12.1 6.57001 12.93 6.57001 13.95C6.57001 14.97 7.40001 15.8 8.42001 15.8C9.44001 15.8 10.27 14.97 10.27 13.95C10.27 12.93 9.45001 12.1 8.42001 12.1Z"
        fill="#111827"
      />
    </svg>
  );
};

export default SettingIcon;
